<template>
  <div class="vehicle-info-page">
    <!-- 顶部导航栏 -->
    <header class="page-header">
      <div class="header-left" @click="handleBack">

      </div>
      <h1 class="page-title">车辆基本信息</h1>

    </header>

    <!-- 车辆信息主体内容 -->
    <div class="info-container">
      <!-- 简化的车牌信息 -->
      <div class="license-section">
        <div class="license-label">车牌号</div>
        <div class="license-number">{{ carManageAddForm.licensePlateNumber || '' }}</div>
      </div>

      <!-- 表单内容 -->
      <div class="form-content">
        <!-- 第一组信息 -->
        <div class="form-section">
          <h3 class="section-title">基本信息</h3>

          <div class="info-item">
            <span class="info-label">道路运输证号</span>
            <span class="info-value">{{ carManageAddForm.transportCertificateNumber || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">车辆类型</span>
            <span class="info-value">{{ getCarTypeName(carManageAddForm.carType) || '' }}</span>
          </div>

          <div class="info-item" v-if="!isCarHailing">
            <span class="info-label">行车日志模板</span>
            <span class="info-value">
              {{ getTemplateNames(carManageAddForm.template) || '' }}
            </span>
          </div>

          <div class="info-item" v-if="!isCarHailing">
            <span class="info-label">准牵引质量（kg）</span>
            <span class="info-value">{{ carManageAddForm.tractionQuality || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">核定载质量（kg）</span>
            <span class="info-value">{{ carManageAddForm.approvedQuality || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">核定载客（人）</span>
            <span class="info-value">{{ carManageAddForm.approvedPeople || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">分组</span>
            <span class="info-value">{{ getGroupName(carManageAddForm.groupId) || '' }}</span>
          </div>

          <div class="info-item" v-if="carManageAddForm.carType + '' == '3'">
            <span class="info-label">挂车车牌号</span>
            <span class="info-value">{{ carManageAddForm.trailerPlateNumber || '' }}</span>
          </div>
        </div>

        <!-- 第二组信息 - 证件信息 -->
        <div class="form-section">
          <h3 class="section-title">证件信息</h3>

          <div class="info-item">
            <span class="info-label">行驶证注册日期</span>
            <span class="info-value">{{ formatDate(carManageAddForm.licenseRegistrationDate) || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">行驶证检验有效期</span>
            <span class="info-value" :class="getExpireClass(carManageAddForm.licenseCheckDate)">{{ formatDate(carManageAddForm.licenseCheckDate) || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">道路运输证审验有效期</span>
            <span class="info-value">{{ formattedTransportCertificate || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">强制报废日期</span>
            <span class="info-value">{{ formatDate(carManageAddForm.scrappedDate) || '' }}</span>
          </div>

          <div class="info-item" v-if="!isCarHailing">
            <span class="info-label">车辆维修时间</span>
            <span class="info-value">{{ formatDate(carManageAddForm.carRepairDate) || '' }}</span>
          </div>
        </div>

        <!-- 第三组信息 - 保险信息 -->
        <div class="form-section">
          <h3 class="section-title">保险信息</h3>

          <div class="info-item">
            <span class="info-label">交强险有效期</span>
            <span class="info-value">{{ formattedTrafficInsurance || '' }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">商业险有效期</span>
            <span class="info-value">{{ commercialInsureText || '' }}</span>
          </div>

          <div class="info-item" v-if="carManageAddForm.template + '' == '3'">
            <span class="info-label">承运人责任险有效期</span>
            <span class="info-value">{{ carrierStartText || '' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 二维码弹窗 -->

  </div>
</template>

<script>
import request from "@/utils/request";

export default {

  data() {
    return {
      // 表单数据模型 - 模拟数据
      carManageAddForm: {
        licensePlateNumber: "",
        transportCertificateNumber: "",
        template: [],
        carType: "",
        tractionQuality: "",
        approvedQuality: "",
        approvedPeople: "",
        groupId: 1,
        trailerPlateNumber: "",
        licenseRegistrationDate: "",
        licenseCheckDate: "",
        scrappedDate: "",
        carRepairDate: ""
      },

      logTemplateAll: [
        {
          name: "客运类型",
          id: "1",
        },
        {
          name: "普货类型",
          id: "2",
        },
        {
          name: "危货类型",
          id: "3",
        },
        {
          name: "网约车",
          id: "4",
        },
      ],
      // 日期范围数据
      transportCertificate: ["2023-03-01", "2024-03-01"],
      trafficInsurance: ["2023-09-01", "2024-09-01"],
      commercialInsure: ["2023-09-01", "2024-09-01"],
      carrierStart: ["2023-09-01", "2024-09-01"],

      // 选择器选项数据
      templateall: [
        { id: 1, name: "普通货运模板" },
        { id: 2, name: "长途运输模板" },
        { id: 3, name: "危险品运输模板" }
      ],
      carTypeoptions: [
        { id: 1, dictName: "小型客车", dictValue: "1" },
        { id: 2, dictName: "重型货车", dictValue: "2" },
        { id: 3, dictName: "半挂牵引车", dictValue: "3" },
        { id: 4, dictName: "大型客车", dictValue: "4" }
      ],
      groupOptions: [
        { id: 1, name: "深圳车队" },
        { id: 2, name: "广州车队" },
        { id: 3, name: "珠海车队" }
      ],

      // 状态控制
      isCarHailing: false,
      showQrModal: false
    };
  },
  computed: {
    // 格式化日期范围文本
    formattedTrafficInsurance() {
      const start = this.formatDate(this.carManageAddForm.trafficInsuranceDate);
      const end = this.formatDate(this.carManageAddForm.trafficInsuranceEndDate);
      // 若开始日期和结束日期都为空，返回空字符串
      if (!start && !end) {
        return '';
      }
      return `${start} 至 ${end}`;
    },

    formattedTransportCertificate(){
      const start = this.formatDate(this.carManageAddForm.transportCertificateStartDate);
      const end = this.formatDate(this.carManageAddForm.transportCertificateEndDate);
      // 若开始日期和结束日期都为空，返回空字符串
      if (!start && !end) {
        return '';
      }
      return `${start} 至 ${end}`;
    },
    commercialInsureText() {
      const start = this.formatDate(this.carManageAddForm.commercialInsureStartDate);
      const end = this.formatDate(this.carManageAddForm.commercialInsureEndDate);
      // 若开始日期和结束日期都为空，返回空字符串
      if (!start && !end) {
        return '';
      }
      return `${start} 至 ${end}`;
    },
    carrierStartText() {
      return this.carrierStart.length === 2
        ? `${this.carrierStart[0]} 至 ${this.carrierStart[1]}`
        : '';
    }
  },

  methods: {
    // 返回按钮处理
    handleBack() {
      window.history.back();
    },
    // 格式化日期为 "YYYY-MM-DD"
    formatDate(dateString) {
      if (!dateString) return ''; // 处理空值
      const date = new Date(dateString);
      // 获取年、月、日（月份+1，因为JS月份从0开始）
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 补0成两位数
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 获取车辆类型名称
    getCarTypeName(value) {
      const item = this.carTypeoptions.find(option => option.dictValue === value);
      return item ? item.dictName : '';
    },
    // 获取分组名称
    getGroupName(id) {
      const item = this.groupOptions.find(option => option.id === id);
      return item ? item.name : '';
    },
    // 获取模板名称集合
    getTemplateNames(template) {
      if (!template) return "";

      // 将字符串按逗号拆分为数组（处理如 "1,3" 这样的格式）
      const templateArr = template.split(',');
      const names = [];

      // 精确匹配数组中的每一项
      if (templateArr.includes("1")) {
        names.push("客运类型");
      }
      if (templateArr.includes("2")) {
        names.push("普货类型");
      }
      if (templateArr.includes("3")) {
        names.push("危货类型");
      }
      if (templateArr.includes("4")) {
        names.push("网约车");
      }

      return names.join(",");
    },
    // 判断日期是否过期
    getExpireClass(dateString) {
      if (!dateString) return '';
      const today = new Date();
      const targetDate = new Date(dateString);
      return targetDate < today ? 'expired' : '';
    }
  },
  mounted() {
    // 处理二维码扫描参数
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleId = urlParams.get('id');
    if (vehicleId) {
      console.log('通过二维码扫描进入，车辆ID:', vehicleId);
      let url = Global.env + Global.apiCore.queryCarDetail + "/" + vehicleId ;
      // let url = Global.env + Global.apiCore.messageDetails + "/" + '611142695208886272' + "/" + '644900177588518912';
      return new Promise((resolve, reject) => {
        request({
          url: url,
          method: 'get', //查询一般为get
        }).then(response => {
          if (response.resultCode == "1000") {
            console.log("carManageAddForm----------:",response.data);
            // 关键：使用 Object.assign 合并属性，确保响应式更新
            // （如果直接赋值新对象，Vue 也能监听，但合并方式更稳妥）
            this.carManageAddForm = Object.assign({}, this.carManageAddForm, response.data);

            // 补充：如果有日期范围数据，也需要同步更新
            this.transportCertificate = response.data.transportCertificate || [];
            this.trafficInsurance = response.data.trafficInsurance || [];
            this.commercialInsure = response.data.commercialInsure || [];
            this.carrierStart = response.data.carrierStart || [];
            if(this.carManageAddForm.template.includes("4")) {
              this.isCarHailing = true;
            }
            console.log("carManageAddForm-2222---------:",this.carManageAddForm);
            return resolve()
          }else {
            return reject(response.resultDesc);
          }

        }).catch(error => {
          return reject(error);

        })
      })
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.vehicle-info-page {
  min-height: 100vh;
  background-color: #f5f7f9;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  padding-bottom: 20px;
}

/* 顶部导航 */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 15px;
  background-color: #1e88e5;
  color: white;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-left, .header-right {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-back {
  width: 22px;
  height: 22px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  display: inline-block;
}

.icon-qrcode {
  width: 22px;
  height: 22px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M15 2v2h2v2h-2v2h-2V6h-2V4h2V2h2zm4 8V8h-2V6c0-1.1-.9-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.1 0-2 .9-2 2v2H2v2h2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8h-2zM5 8h14v8H5V8zm7 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z'/%3E%3C/svg%3E");
  background-size: contain;
}

.page-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  text-align: center; /* 标题文字居中 */
  flex: 1; /* 让标题占据剩余空间，实现居中 */
}

/* 信息容器 */
.info-container {
  padding: 15px;
}

/* 简化的车牌信息展示 */
.license-section {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.license-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.license-number {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  letter-spacing: 1px;
  font-family: 'SimHei', sans-serif;
  padding: 8px 0;
  border-radius: 6px;
  background-color: #f9f9f9;
  text-align: center;
}

/* 表单内容 */
.form-content {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  opacity: 1;
  transform: translateY(0);
}

.form-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.section-title {
  font-size: 16px;
  color: #1e88e5;
  margin: 0 0 15px 0;
  padding-left: 5px;
  border-left: 3px solid #1e88e5;
}

.info-item {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  flex: 0 0 120px;
  color: #666;
  font-size: 14px;
  padding-right: 10px;
  box-sizing: border-box;
}

.info-value {
  flex: 1;
  color: #333;
  font-size: 14px;
  word-break: break-all;
}

.info-value.expired {
  color: #e74c3c;
  font-weight: 500;
}

/* 二维码弹窗 */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-content {
  background-color: white;
  width: 85%;
  max-width: 320px;
  border-radius: 10px;
  overflow: hidden;
  animation: popIn 0.3s ease;
}

@keyframes popIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* 响应式调整 */
@media (max-width: 375px) {
  .info-label {
    flex: 0 0 100px;
    font-size: 13px;
  }

  .info-value {
    font-size: 13px;
  }

  .license-number {
    font-size: 20px;
  }
}

@media (max-width: 320px) {
  .info-label {
    flex: 0 0 90px;
  }
}
</style>
